export function getCountryName(countryCode, languageCode) {
  const lang = (languageCode || "").toLowerCase().startsWith("ru") ? "ru" : "en";

  // fallback если вдруг Intl.DisplayNames не поддерживается
  if (!("DisplayNames" in Intl)) {
    const map = {
      RU: { ru: "Россия", en: "Russia" },
      DE: { ru: "Германия", en: "Germany" },
    };
    return map[countryCode]?.[lang] ?? countryCode;
  }

  const dn = new Intl.DisplayNames([lang], { type: "region" });
  return dn.of(countryCode) ?? countryCode;
}
